import { createContext } from 'react'

export const getSessionStorageValue = (key: string, defaultValue = {}) => {
  const storedValue = sessionStorage.getItem(key)
  return storedValue ? JSON.parse(storedValue) : defaultValue
}

export interface UrlParamsContextState {
  urlQueries: Record<string, string>
  setUrlQueries: (
    urlQueries: Record<string, string>,
    remember?: boolean
  ) => void
}

const initialState: UrlParamsContextState = {
  urlQueries: {},
  setUrlQueries: console.log
}

const UrlParamsContext = createContext<UrlParamsContextState>(initialState)

export default UrlParamsContext
